import type { ChangeEvent, FC } from "react";
import React, { useCallback } from "react";
import cx from "classnames";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";

import { ExerciseBody } from "../../exercise_body";
import type { ExerciseQuestionType } from "../../../types/main";

import "./styles.scss";

type Props = {
    onAnswer: (answer: Record<string, boolean>, questionId: number) => void;
    question: ExerciseQuestionType;
    questionNumber: number;
    userAnswers?: Record<string, boolean>;
};

export const QuestionMultiple: FC<Props> = ({ onAnswer, question, questionNumber, userAnswers }: Props) => {
    const handleMultipleAnswer = useCallback(
        (event: ChangeEvent<HTMLInputElement>) =>
            onAnswer(
                {
                    ...(userAnswers || {}),
                    [event.target.name]: event.target.checked,
                },
                question.id
            ),
        [userAnswers, onAnswer, question.id]
    );

    const answers = question.answers ?? [];

    const firstAnswersColumnLength = Math.ceil(answers.length / 2);

    return (
        <div
            className={cx("question-multiple", {
                "question-multiple--size-large": question.size === "L",
            })}
        >
            {question.instruction && (
                <div
                    className="question-multiple__instruction"
                    dangerouslySetInnerHTML={{ __html: question.instruction }}
                />
            )}
            {question.context && <div dangerouslySetInnerHTML={{ __html: question.context }} />}
            <ExerciseBody number={questionNumber} text={question.text} topic={null} />
            <p>Отметьте несколько вариантов.</p>
            {question.showAnswersColumns ? (
                <div className="question-multiple__columns">
                    <div className="question-multiple__column">
                        <FormGroup>
                            {answers.slice(0, firstAnswersColumnLength).map((a) => (
                                <FormControlLabel
                                    key={`answer_${a.id}`}
                                    control={
                                        <Checkbox
                                            checked={userAnswers?.[a.id]}
                                            name={a.id.toString()}
                                            onChange={handleMultipleAnswer}
                                        />
                                    }
                                    label={<span dangerouslySetInnerHTML={{ __html: a.text }} />}
                                />
                            ))}
                        </FormGroup>
                    </div>
                    <div className="question-multiple__column">
                        <FormGroup>
                            {answers.slice(firstAnswersColumnLength).map((a) => (
                                <FormControlLabel
                                    key={`answer_${a.id}`}
                                    control={
                                        <Checkbox
                                            checked={userAnswers?.[a.id]}
                                            name={a.id.toString()}
                                            onChange={handleMultipleAnswer}
                                        />
                                    }
                                    label={<span dangerouslySetInnerHTML={{ __html: a.text }} />}
                                />
                            ))}
                        </FormGroup>
                    </div>
                </div>
            ) : (
                <FormGroup>
                    {answers.map((a) => (
                        <FormControlLabel
                            key={`answer_${a.id}`}
                            control={
                                <Checkbox
                                    checked={userAnswers?.[a.id]}
                                    name={a.id.toString()}
                                    onChange={handleMultipleAnswer}
                                />
                            }
                            label={<span dangerouslySetInnerHTML={{ __html: a.text }} />}
                        />
                    ))}
                </FormGroup>
            )}
        </div>
    );
};
